var _this = this;
import * as tslib_1 from "tslib";
import { getUserConfiguration } from 'owa-session-store';
import { lazySendAutomatedMessage } from 'owa-automated-message';
import { searchDiagnosticsStore } from 'owa-search-diagnostics';
import { userVoiceSuggestionStore } from 'owa-uservoice';
import { UserVoiceSearchTeam } from '../components/SearchInContextFeedbackDialog';
export default (function (userVoiceFeedbackTeam) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var sendAutomatedMessage, messageDetails, timeFormat;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, lazySendAutomatedMessage.import()];
            case 1:
                sendAutomatedMessage = _a.sent();
                messageDetails = {
                    subject: 'OWA 3S Query Feedback',
                    message: buildMessage(),
                    to: userVoiceFeedbackTeam == UserVoiceSearchTeam.CalendarSearch
                        ? ['owasearchdog@microsoft.com']
                        : ['owa3squeryfeedback@service.microsoft.com'],
                    attachments: null,
                };
                timeFormat = getUserConfiguration().UserOptions.TimeFormat;
                sendAutomatedMessage(messageDetails, timeFormat);
                return [2 /*return*/];
        }
    });
}); });
var buildMessage = function () {
    var feedbackCategories = userVoiceSuggestionStore.customFields
        .map(convertFeedbackCategoryToChecklistItem)
        .join('\n');
    var searchInstrumentationEntries = searchDiagnosticsStore.searchInstrumentationList.slice();
    searchInstrumentationEntries.forEach(function (instrumentation) {
        // Strip out PII data
        delete instrumentation.PIIData;
        // Add resource timing entries to top level of the object
        if (instrumentation.ResourceTimingEntry) {
            Object.keys(instrumentation.ResourceTimingEntry).forEach(function (key) {
                // Skip the rollup resource timing data
                if (key == 'cpv') {
                    return;
                }
                instrumentation[key] = instrumentation.ResourceTimingEntry[key];
            });
        }
        delete instrumentation.ResourceTimingEntry;
    });
    var searchInstrumentation = convertAllInstrumentationToTable(searchInstrumentationEntries);
    var message = "<h2>Categories</h2>" + feedbackCategories + " \n\n\n\n        <h2>Verbatim</h2>" + userVoiceSuggestionStore.message + "\n\n\n\n        <h2>Search History</h2>" + searchInstrumentation.replace(/\n/g, '');
    return message.replace(/\n/g, '<br />');
};
var convertFeedbackCategoryToChecklistItem = function (c) {
    return (c.Value ? String.fromCharCode(9745) : String.fromCharCode(9744)) + "&nbsp;" + c.Name;
};
var convertAllInstrumentationToTable = function (instrumentation) {
    return instrumentation == null || instrumentation.length == 0
        ? null
        : "<table border=\"1\">\n            " + extractInstrumentationTableHeaders(instrumentation) + "\n            " + convertInstrumentationToTableRows(instrumentation) + "\n        </table>";
};
var getDisplayFieldForKey = function (key) {
    if (key == 'SearchQueryId') {
        return 'SearchConversationId';
    }
    return key;
};
var extractInstrumentationTableHeaders = function (instrumentation) {
    return "<thead><tr>\n        " + Object.keys(instrumentation[0])
        .map(function (key) { return "<th>" + getDisplayFieldForKey(key) + "</th>"; })
        .join('') + "\n    </tr></thead>";
};
var convertInstrumentationToTableRows = function (instrumentation) {
    return instrumentation
        .map(function (e) {
        return "<tr>\n                    " + Object.keys(e)
            .map(function (key) { return convertInstrumentationFieldToTableCell(e[key]); })
            .join('') + "\n                </tr>";
    })
        .join('');
};
var convertInstrumentationFieldToTableCell = function (field) {
    if (field === undefined || field === null) {
        return '<td></td>';
    }
    else if (field instanceof Array) {
        return "<td>" + field.join(',') + "</td>";
    }
    else if (field instanceof Date) {
        return "<td>" + field.toISOString() + "</td>";
    }
    else {
        return "<td>" + field.toString() + "</td>";
    }
};
//# sourceMappingURL=sendSearchFeedback.js.map